import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useFormContext } from 'react-hook-form';

import Checkbox from '@lib/inputs/Checkbox';
import AddressFields from './AddressFields';
import { ADDRESS_TYPE } from '../constants/voterRegistrationConstants';
import { IVoterRegistrationFormValues } from '../voterRegistrationTypes';

function MailingAddressSection() {
    const intl = useIntl();
    const {
        watch,
        setValue,
    } = useFormContext();
    const isMailingSameAsResidential = watch('mailingAddress.isMailingSameAsResidential');

    const handleFieldChange = (name: string, value: any) => {
        setValue(name as keyof IVoterRegistrationFormValues, value, {
            shouldValidate: true,
            shouldDirty: true,
        });
    };

    const onSameMailingAddressCheckboxChange = (isChecked: boolean) => {
        handleFieldChange('mailingAddress.isMailingSameAsResidential', isChecked);
        if (isChecked) {
            handleFieldChange('mailingAddress.addressLine', '');
            handleFieldChange('mailingAddress.unitNo', '');
            handleFieldChange('mailingAddress.unitType', '');
            handleFieldChange('mailingAddress.city', '');
            handleFieldChange('mailingAddress.state', '');
            handleFieldChange('mailingAddress.zipCode', '');
            handleFieldChange('mailingAddress.county', '');
        }
    };

    return (
        <>
            <FormattedMessage id="voterRegistration.form.mailingAddress.header" tagName="h2" />
            <div id="mailingAddress-section">
                <Checkbox
                    label={{
                        text: intl.formatMessage({ id: 'voterRegistration.form.mailingAddress.sameAsResidential' }),
                    }}
                    inputData={{
                        id: 'mailingAddress.isMailingSameAsResidential',
                        name: 'mailingAddress.isMailingSameAsResidential',
                        classes: ['margin-top-4'],
                        checked: isMailingSameAsResidential,
                    }}
                    inputActions={{
                        handleFieldChange: onSameMailingAddressCheckboxChange,
                    }}
                />
                {!isMailingSameAsResidential && <AddressFields addressType={ADDRESS_TYPE.MAILING} />}
            </div>
        </>
    );
}

export default MailingAddressSection;
